import { spacing, breakpoint, mediaQueryHelper, fontSize, fontWeight, colors } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  checkbox: css({
    marginTop: spacing.default,
  }),
  select: css({
    width: '100%',
    marginBottom: spacing.medium,

    label: {
      marginTop: spacing.small,
    },
  }),
  formFooter: css({
    paddingTop: spacing.large,
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column-reverse',

    [mediaQueryHelper(breakpoint.phone)]: {
      flexDirection: 'row',
    },
  }),

  button: css({
    width: '100%',

    [mediaQueryHelper(breakpoint.phone)]: {
      width: 'auto',
      marginLeft: spacing.default,
    },

    [mediaQueryHelper(breakpoint.phone, 'max-width')]: {
      marginTop: spacing.default,
    },
  }),

  comprehensiveLocationNotification: css({
    marginBottom: spacing.small,
  }),

  heading: css({
    fontWeight: fontWeight.semiBold,
    color: colors.blackPearl,
  }),
}

export default styles
